import type { TFunction } from 'i18next';

/**
 * Translate an unknown error from ``POST /speech-to-text/.../publish``
 * into the sentence the user should see. The two 409 details the
 * backend raises for a mis-shaped new-video request (#4101 Gap D) get
 * dedicated keys so the toast names the actual remediation — toggle
 * the org setting, or reconnect the account — instead of surfacing an
 * untranslated backend string.
 */
export function translatePublishStartError(err: unknown, t: TFunction): string {
  const data = (
    err as {
      response?: {
        data?: { error_description?: string; detail?: string };
      };
    }
  )?.response?.data;
  const detail = data?.detail ?? null;
  if (detail === 'publishing-video-uploads-disabled') {
    return t('publish-start-failed-video-uploads-disabled');
  }
  if (detail === 'publishing-platform-not-allowed') {
    return t('publish-start-failed-platform-not-allowed');
  }
  if (detail === 'publishing-video-uploads-not-allowed') {
    return t('publish-start-failed-video-uploads-not-allowed');
  }
  if (detail === 'publishing-connection-missing-upload-scope') {
    return t('publish-start-failed-missing-upload-scope');
  }
  return data?.error_description ?? t('publish-start-failed');
}
